






































































































import {Component, Provide, Vue} from 'vue-property-decorator';
import Role from '@/models/role';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Utils} from '@/utils/Utils';
import {Filter} from '@/utils/Filter';
import AssignRoleModal from '@/components/AssignRoleModal.vue';
import {mapActions, mapGetters} from 'vuex';
import {
  getRoleList,
  updateRole,
  deleteRole,
  assignRole,
  getAssignedRoleList,
  updateRoleStatus,
} from '@/services/api/roles';
import User from '@/models/user';
import {API} from '@/services/api/api';

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast']),
  },
  components: {
    FilterMenu,
    Paginition,
    AssignRoleModal,
  },
})
export default class RoleList extends Vue {
  header = [
    {
      value: 'groupName',
      name: 'Role Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'active',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      asdcOrder: false,
      bindClass: 'text-center',
    },
    {
      value: 'createdDate',
      name: 'Created',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: '',
      name: '',
    },
  ];

  roleList: Role[] = [];

  filteredRoleList: Role[] = [];
  numberOfRows = 5;
  startingPoint = 0;
  endingPoint = 5;
  curentSort = '';
  asdcOrder = true;
  userList = [];

  roleId: any = null;
  deleteStatus: any = null;

  //Modal & Loader Variables
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  showSuccessToast: any;
  showErrorToast: any;

  mounted() {
    this.fetchRoleList();
  }

  //fetch list from api
  async fetchRoleList() {
    this.isScreenLoading = true;

    try {
      let roleListReq = getRoleList();
      let userListReq: any = API.getUserList();
      let usersRolesReq: any = getAssignedRoleList();
      const responses = await Promise.all([roleListReq, usersRolesReq, userListReq]);

      const rolesResponse = responses[0];
      const assignedUsers: any[] = responses[1].data;
      const users: User[] = responses[2].data;
      this.userList = this.mapUsersAndRoles(assignedUsers, users);

      if (rolesResponse.data) {
        let list: Role[] = rolesResponse.data;
        this.roleList = list;
        this.filteredRoleList = list;
      } else {
        this.showErrorToast({msg: rolesResponse.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //helper methods
  mapUsersAndRoles(rolesAndUsers = [], users: User[]) {
    let list = [];
    users.forEach((usr) => {
      const roles = rolesAndUsers.find((roleUser) => usr.id === roleUser.vopUserId);
      const groupId = roles ? roles.groupId : null;
      list.push({...usr, groupId});
    });
    return list;
  }
  //assign Role
  async assignRoleCb(userId, groupId) {
    const assignedRole = {
      GroupId: groupId,
      Users: [{UserId: userId}],
    };
    try {
      let response: any = await assignRole(assignedRole);
      this.fetchRoleList();
      if (response.data) {
        let message: string = response.message;
        if (message.includes('Successfully assigned role')) message = 'Role is assigned to selected user.';
        this.showSuccessToast({msg: message});
      } else {
        let errorMsg = response.error;
        this.showErrorToast({msg: errorMsg});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredRoleList);
    this.asdcOrder = sorted;
  }

  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number, records: number) {
    this.numberOfRows = records;
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.roleList);
    this.filteredRoleList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.roleList);
    this.filteredRoleList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredRoleList = this.roleList;
      this.resetPagination();
    }
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: number) {
    this.roleId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordLoginStatus: boolean, recordEnableStatus: boolean) {
    this.roleId = recordId;
    let msg;
    if ((recordLoginStatus && !recordEnableStatus) || (recordLoginStatus && recordEnableStatus)) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    msg = msg.toLowerCase();
    this.modalConfimationMsg = `Are you sure want to ${msg} ?`;
    this.deleteStatus = false;
  }

  async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus ? await deleteRole(this.roleId) : await this.changeStatus(this.roleId);

      const message = this.deleteStatus ? 'Record deleted successfully' : 'Record updated successfully';

      if (response) {
        this.showSuccessToast({msg: message});
        this.fetchRoleList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  changeStatus(roleId) {
    const role = this.roleList.find((u) => u.groupId === roleId);
    const status = !role.active;
    return updateRoleStatus({Active: status}, this.roleId);
  }

  editRole(roleId: number) {
    this.$router.push('/edit-role/' + roleId);
  }
  gotoCreateRole() {
    this.$router.push('/create-role');
  }
}
